<template>
    <div :class="computed_cols + ' ' + (vertical ? 'align-self-'+vertical : '')">
        <div :class="(title ? 'mb-3 ' : '') + 'form-group neutron'">
            <label :for="computed_id" v-if="title">
                <span class="text-wrap">
                    {{title}}
                </span>
                <i v-if="required == 'true'" class="fas fa-shield-alt"></i>
            </label>
            <select v-if="options"
                class="selectpicker form-control" 
                :multiple="multiple >= 0"
                :name="(multiple == 0 || multiple > 1) ? (name + '[]') : name"
                :disabled="disabled == 'true' ? true : false"
                :data-header="header ? header : ''"
                :data-actions-box="actions == 'true' ? true : false"
                :data-size="size ? size : 'auto'"
                :data-style="color ? ('btn-'+color) : 'btn-light'"
                :title="placeholder ? placeholder : (required == 'true') ? 'Debe seleccionar' : 'No hay selección'"
                :data-live-search="search == 'true' ? true : false"
                :required="required == 'true'"
                :data-max-options="multiple ? multiple : 1"
                data-show-subtext="true"
                :id="computed_id">
                <option 
                    v-for="option in options" 
                    :key="option.id" 
                    :data-icon="option.icon ? option.icon : null"
                    :data-subtext="option.subtext ? option.subtext : null"
                    :value="option.id">
                    {{option.text}}
                </option>
            </select>
            <select v-if="url"
                class="selectpicker form-control" 
                :multiple="multiple >= 0"
                :name="multiple > 0 ? (name + '[]') : name"
                :disabled="disabled == 'true' ? true : false"
                :data-header="header ? header : ''"
                :data-actions-box="actions == 'true' ? true : false"
                :data-size="size ? size : 'auto'"
                :data-style="color ? ('btn-'+color) : 'btn-light'"
                :title="placeholder ? placeholder : (required == 'true') ? 'Debe seleccionar' : 'No hay selección'"
                :data-live-search="search == 'true' ? true : false"
                :required="required == 'true'"
                :data-max-options="multiple ? multiple : false"
                data-show-subtext="true"
                :id="computed_id">
                <option 
                    v-for="item in data" 
                    :key="item.id" 
                    :data-icon="item.icon ? item.icon : null"
                    :data-subtext="item.subtext ? item.subtext : null"
                    :value="item.id">
                    {{item.text}}
                </option>
            </select>
            <select v-if="!url && !options" 
                class="selectpicker form-control"
                :data-header="header ? header : ''">
            </select>
        </div>
    </div>
</template>

<script>
import selectpicker from "bootstrap-select";
import Axios from 'axios';

export default {
    props: [
        'value',
        'id',
        'multiple',
        'weight',
        'title',
        'required',
        'vertical',
        'search',
        'placeholder',
        'color',
        'size',
        'actions',
        'header',
        'disabled',
        'options',
        'selected',
        'url',
        'parent',
        'name',
    ],
    data() { return {
        data: [],
        blocking: false,
    }},
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('select-' + this._uid);
            } else {
                return this.id;
            }
        },
        computed_cols() {
            switch (this.weight) {
                case '0':
                    return 'col';            
                case '1':
                    return 'col-12';            
                case '2':
                    return 'col-xs-12 col-sm-6';            
                case '3':
                    return 'col-xs-12 col-sm-6 col-lg-4';            
                case '4':
                    return 'col-xs-12 col-sm-6 col-lg-4 col-xxl-3';            
                default:
                    return 'col-xs-12 col-sm-6 col-lg-4';
            }
        }
    },
    mounted() {
        const vm = this;
        const select = $('#'+vm.computed_id);

        if(vm.selected) {
            setTimeout(() => {
                if(vm.selected == 'auto') {
                    select.selectpicker('val', vm.options[0].id);
                    vm.$emit('input', vm.options[0].id);
                } else {
                    select.selectpicker('val', vm.selected);
                    vm.$emit('input', vm.selected);
                }            
            }, 500);
        }

        if(vm.url && !vm.parent && !vm.options) {  
            vm.ajax(vm.url);
        }

        select.on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            if(!vm.blocking) {
                const valor = select.selectpicker('val');
                vm.$emit('input', (Array.isArray(valor) && valor.length == 0 ? null : valor));
            } else {
                vm.blocking = false;
            }
        });

        vm.$on('refrescarData', function() {
            setTimeout(() => {
                select.selectpicker('refresh');
            }, 100);
        });

        if(vm.parent) {
            vm.$parent.$on('broadcastPadreCambio', function(padre) {
                if(Array.isArray(vm.parent)) {
                    vm.parent.forEach(item => {
                        if(item == padre) {
                            vm.ajax(vm.url);
                        }
                    });
                } else {
                    if(vm.parent == padre) {
                        vm.ajax(vm.url);
                    }
                }
            });
        }
    },
    methods: {
        ajax: function(url) {
            Axios.get(url).then(res => {
                this.data = res.data;
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 
                        'Error en el componente n-select '+this.computed_id
                    );
                }
            })
        }
    },
    watch: {
        data() {
            this.$emit('refrescarData');
        },
        value(newVal, oldVal) {  
            if (this.multiple >= 0) {
                if (!(Array.isArray(oldVal) && Array.isArray(newVal)
                && oldVal.length === newVal.length
                && newVal.reduce((acum, e) => !(oldVal.includes(e) && acum) ? true : false   ,false)))
                {
                    this.blocking = true;
                    $('#'+this.computed_id).selectpicker('val', newVal);
                }
            } else {
                if(oldVal != newVal) {
                    this.blocking = true;
                    $('#'+this.computed_id).selectpicker('val', newVal);
                }
            }
            this.$parent.$emit('padreCambio', this.computed_id);
        },
        options (oldVal, newVal) {
            if ( this.multiple >= 0 ){
                if (!(Array.isArray(oldVal) && Array.isArray(newVal)
                && oldVal.length === newVal.length
                && newVal.reduce((acum, e) => !(oldVal.includes(e) && acum) ? true : false   ,false))){
                    setTimeout(()=>{
                        $(`#${this.computed_id}`).selectpicker('refresh');
                        $('#'+this.computed_id).selectpicker('val', this.value);
                        this.$parent.$emit('padreCambio', this.computed_id);
                    },100)
                }
            }else {
                setTimeout(()=>{
                        $(`#${this.computed_id}`).selectpicker('refresh');
                        $('#'+this.computed_id).selectpicker('val', this.value);
                        this.$parent.$emit('padreCambio', this.computed_id);
                    },100)
            }
            
        }
    }
}
</script>